export * from './format-utils';

export const num = (v: string | undefined) => parseFloat(v || '0') || 0;

export function formatCurrency(v: unknown): string {
  if (v === null || v === undefined) return '$0.00';
  if (typeof v === 'number') {
    if (!isFinite(v)) return '$0.00';
    return '$' + v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  // Convert anything else (string, object, array) to a string first
  const s = String(v);
  const n = parseFloat(s.replace(/[^0-9.-]/g, '') || '0') || 0;
  return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function stripCurrency(v: unknown): string {
  if (typeof v === 'number') return String(v);
  return String(v ?? '').replace(/[^0-9.-]/g, '') || '';
}
